<template>
  <div>
    <ConfirmationModal
      title="Confirm payment"
      toolbarColor="primary"
      contentText="The total amount received so far is less than the net fee. Do you want to continue?"
      :showModal="showWarningPaymentMessage"
      @ok-click="saveRecordPayment"
      @cancel-click="handleConfirmationPaymentCancel"
    ></ConfirmationModal>
    <ConfirmationModal
      toolbarColor="red"
      title="Confirm amount charge back"
      contentText="The amount is a charge back commission, continue?"
      :showModal="showWarningChargeBackMessage"
      @ok-click="saveRecordPayment"
      @cancel-click="handleConfirmationChargeBackCancel"
    ></ConfirmationModal>
    <DynamicModal
      :showModal="showModalProp"
      title="Record Payment"
      :persistent="false"
      @clickOutside="closeModal"
      maxWidth="800px"
    >
      <v-container fluid slot="title-buttons" class="py-1">
        <v-row justify="end">
          <v-btn
            icon
            depressed
            color="primary"
            @click="closeModal"
          >
            <v-icon color="white">close</v-icon>
          </v-btn>
        </v-row>
      </v-container>
      <v-container fluid slot="content">
        <DirectPlacementPaymentInput
          class="mt-3"
          ref="DirectPlacementInput"
        />
      </v-container>
      <v-container fluid slot="buttons" class="pb-0 mb-0">
        <div class="row d-flex justify-end">
          <div class="col-6">
            <v-btn
              block
              depressed
              color="primary"
              @click="validatePaidInFull"
            >
              Save
            </v-btn>
          </div>
          <div class="col-6">
            <v-btn
              block
              depressed
              outlined
              @click="closeModal"
            >
              Cancel
            </v-btn>
          </div>
        </div>
      </v-container>
    </DynamicModal>
  </div>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { ConfirmationModal, DynamicModal } from '@/components/dialogs'
import { DirectPlacementPaymentInput } from '@/components/directPlacementPayments'

export default {
  components: {
    ConfirmationModal,
    DynamicModal,
    DirectPlacementPaymentInput
  },
  props: [
    'netFee'
  ],
  data: () => ({
    showModalProp: false,
    showWarningPaymentMessage: false,
    showWarningChargeBackMessage: false
  }),
  computed: {
    ...mapFields('directPlacementPayments', [
      'directPlacementPaymentList'
    ]),
    ...mapFields('directPlacementPayment', [
      'id',
      'receivedAt',
      'amount'
    ]),
    isPaidInFullValid () {
      let totalPaid = 0.0
      this.directPlacementPaymentList.forEach(payment => {
        if (payment.id !== this.id) {
          totalPaid += parseFloat(payment.amount)
        }
      })
      return ((totalPaid + parseFloat(this.amount)) >= this.netFee)
    }
  },
  methods: {
    showModal () {
      this.showModalProp = true
    },
    closeModal () {
      this.$refs.DirectPlacementInput.$refs.PlacementPaymentForm.resetValidation()
      this.showModalProp = false
    },
    validatePaidInFull () {
      if (this.$refs.DirectPlacementInput.$refs.PlacementPaymentForm.validate()) {
        if (!this.isPaidInFullValid) {
          this.showWarningPaymentMessage = true
          this.closeModal()
          return
        }
        this.saveRecordPayment()
      }
    },
    saveRecordPayment () {
      this.showWarningPaymentMessage = false
      this.showWarningChargeBackMessage = false
      this.closeModal()
      this.$emit('saveRecordPayment')
    },
    handleConfirmationPaymentCancel () {
      this.showWarningPaymentMessage = false
      this.showModal()
    },
    handleConfirmationChargeBackCancel () {
      this.showWarningChargeBackMessage = false
      this.showModal()
    }
  }
}
</script>
